<template>
  <div>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat"
      class="navbarBtnTashxis"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать
    </b-button>
    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2 mr-2 ml-2"
      v-b-modal="'modal-shablon' + 'tekshirish' + modalIdCom"
      @click="getShablonDoctor('tekshirish', { type: false })"
    >
      <b-icon icon="arrow-down-circle-fill"></b-icon>
    </b-button>

    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2"
      @click="status = 'tekshirish', row_click_type = { type: false }"
      v-b-modal="'modal-new-shab-creat-tekshirish' + modalIdCom"
    >
      <b-icon icon="arrow-up-circle-fill"></b-icon>
    </b-button>
    <b-modal
      :id="'modal-shablon' + 'tekshirish' + modalIdCom"
      size="lg"
      :title="$t('Шаблонлар рўйхати')"
      hide-footer
    >
      <Shablon
        :modalIdCom="modalIdCom"
        :plus_dont_show="true"
        :shabType="'tekshirish'"
        :itemsShablon="itemsShablon"
        @ShablonGet="getShablon"
        @RowClickedShab="RowClickedShab"
      />
    </b-modal>
    <b-modal
              :id="'modal-new-shab-creat-tekshirish' + modalIdCom"
              :title="$t('Шифокор шаблон')"
              
              hide-footer
            >
              <div>
                <div>
                  <b-input type="text" v-model="name"></b-input>
                </div>
              </div>
              <div class="CreateName">
                <b-button
                  class="modalBtn1"
                  size="sm"
                  style="height: 37px;"
                  variant="danger "
                  @click="ShifokorShablonClose"
                >
                  <b-icon icon="calendar2-x"></b-icon>
                  {{ $t("Бекор қилиш") }}
                </b-button>
                <b-button
                  class="mt-3 ml-2 modalBtn"
                  @click="ShifokorShablon"
                  variant="success"
                >
                  <b-icon icon="calendar2-plus"></b-icon>
                  {{ $t("Сақлаш") }}
                </b-button>
              </div>
            </b-modal>
    <div style="display: flex; justify-content: space-between;">
      <div class="stat-bemor-text">
        <label>Sana </label>
        <input 
          type="date"
          class="input-stile"
          @input="textChange"
          v-model="selectShablonJson.value119"
        >
        <h3 class="sarlovha-style">
          Shifokorning bo'limdagi ko'ruvi
        </h3>
        <label>Bemorning shifoxonaga kelgan vaqtidagi shikoyati:</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'tekshirish' + modalIdCom"
          @click="getShablonDoctor('karta_value1', { type: true, value: 'value1'})"
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'karta_value1'),
              (row_click_type = { type: true, value: 'value1' })
          "
          v-b-modal="'modal-new-shab-creat-tekshirish' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
            v-model="selectShablonJson.value1"
            @input="textChange($event)"
            rows="3"
            style="width: 100%;"
          ></textarea>
        <label>Anamnesis morbi (ushbu kasallik tarixi):</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'tekshirish' + modalIdCom"
          @click="getShablonDoctor('tek_value2', { type: true, value: 'value2'})"
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'tek_value2'),
              (row_click_type = { type: true, value: 'value2' })
          "
          v-b-modal="'modal-new-shab-creat-tekshirish' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          max-rows="10"
          style="width: 100%;"
          v-model="selectShablonJson.value2"
          class="input-stile-textarea"
          @input="textChange"
        ></textarea>
        <div>
          <h3 class="sarlovha-style">Epidemiologik anamnez</h3>
        </div>
        <div class="display-flex">
          <input
            v-model="selectShablonJson.value3"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value3', 'tek_value3')"
            @input="textChange($event)"
            style="width: 300px;"
            class="input-stile"
            type="text"
          />
          <label>yuqumli kasalliklar</label>
          <input
            v-model="selectShablonJson.value4"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value4', 'tek_value4')"
            @input="textChange($event)"
            style="width: 300px;"
            class="input-stile"
            type="text"
          />
        </div>
        <label>bilan og'rigan bemorlar (kasallik inkubatsion davrini hisobga olgan holda) bilan muomalada bo'lganmi.</label>
        <div>
          <label>Muloqotda bo'lgan vaqti:</label>
          <input 
            style="width: calc(100% - 500px);"
            type="text"
            @input="textChange($event)"
            class="input-stile"
            v-model="selectShablonJson.value5"
          >
          <label>dan</label>
          <input 
            style="width: 150px;"
            type="text"
            @input="textChange($event)"
            class="input-stile"
            v-model="selectShablonJson.value6"
          >
          <label>gacha</label>
        </div>
        <div>
          <label>Haqiqiy kasallik boshlanishidan 1-hafta - 2 oy avval axoli yashash joyidan chetda bo'lganmi</label>
        </div>
        <div class="display-flex">
          <div
            @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value7'})"
            style="width: 130px; margin-right: 10px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value7"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value7"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <div
            @click="selectKey('tek_value8'), (row_click_type = {type: true, value: 'value8'})"
            style="width: 450px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value8"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value8"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
            <div class="izoh-style">qayerda bo'lgan va qachon qaytib kelgan</div>
          </div>
        </div>
        <div class="display-flex">
          <label>Qanday yuqumli kasalliklar bilan og'rigan?</label>
          <input
            v-model="selectShablonJson.value9"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value9', 'tek_value9')"
            @input="textChange($event)"
            style="width: 400px;"
            class="input-stile"
            type="text"
          />
        </div>
        <div class="sarlovha">So'ngi 6 oy ichida:</div>
        <div class="display-flex">
          <label>Statsionar yoki ambulator davolanishda bo'lganimi?</label>
          <div
            @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value10'})"
            style="width: 130px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value10"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value10"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Gemotransfuziya (Qon va uning komponentlari) o'tkazilganmi?</label>
          <div
            @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value11'})"
            style="width: 130px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value11"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value11"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Bemorga jarrohlik muolajalari o'tkazilganmi?</label>
          <div
            @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value12'})"
            style="width: 130px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value12"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value12"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <label>Parenteral muolajalar (jumladan, igna bilan davolash) qabul qilinganmi?</label>
        <input 
          class="input-stile" 
          style="width: 100%;" 
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value13', 'tek_value13')"
          @input="textChange($event)"
          type="text"
          v-model="selectShablonJson.value13"
        ></input>
        <label>Maishiy xizmat turlaridan foydalanganmi (manikyur, pedikyur, tatuaj, ...)</label>
        <input 
          class="input-stile" 
          style="width: 100%;" 
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value14', 'tek_value14')"
          @input="textChange($event)"
          type="text"
          v-model="selectShablonJson.value14"
        ></input>
        <div class="izoh-style">Xizmat turi, joyi va vaqtini ko'rsating</div>

        <div class="display-flex">
          <label>Xavfli omillar:</label>
          <input 
            style="width: 500px;"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value15', 'tek_value15')"
            @input="textChange($event)"
            class="input-stile" 
            type="text"
            v-model="selectShablonJson.value15"
          ></input>
        </div>

        <div class="display-flex">
          <label>Nasliy kasalliklar:</label>
          <input 
            style="width: 500px;"
            class="input-stile" 
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value16', 'tek_value16')"
            @input="textChange($event)"
            type="text"
            v-model="selectShablonJson.value16"
          ></input>
        </div>
        <label>Anamnesis vitae (bemorning hayot tarixi, kechirgan kasalliklari)</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'tekshirish' + modalIdCom"
          @click="getShablonDoctor('tek_value17', { type: true, value: 'value17'})"
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'tek_value17'),
              (row_click_type = { type: true, value: 'value17' })
          "
          v-b-modal="'modal-new-shab-creat-tekshirish' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea 
          max-rows="10"
          style="width: 100%;"
          @input="textChange($event)"
          class="input-stile-textarea"
          v-model="selectShablonJson.value17"
        >
        </textarea>
        <label>O'tkazgan operatsiyalari:</label>

        <input 
          class="input-stile" 
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value18', 'tek_value18')"
          @input="textChange($event)"
          style="width: 500px;"
          v-model="selectShablonJson.value18"
        >
        <label>Ishlaydigan kasbi:</label>
        <input 
          class="input-stile" 
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value19', 'tek_value19')"
          @input="textChange($event)"
          style="width: 500px;"
          v-model="selectShablonJson.value19"
        >
        <div class="display-flex">
          <label>Ovqatlanish tartibi:</label>
          <div
            @click="selectKey('tek_value20'), (row_click_type = {type: true, value: 'value20'})"
            style="width: 500px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value20"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value20"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Moddiy-maishiy sharoiti:</label>
          <div
            @click="selectKey('tek_value21'), (row_click_type = {type: true, value: 'value21'})"
            style="width: 500px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value21"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value21"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Salbiy odatlari:</label>
          <div
            @click="selectKey('tek_value22'), (row_click_type = {type: true, value: 'value22'})"
            style="width: 500px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value22"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value22"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Alkagol ichimliklar istemoli:</label>
          <div
            @click="selectKey('tek_value23'), (row_click_type = {type: true, value: 'value23'})"
            style="width: 480px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value23"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value23"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Oilaviy ahvoli:</label>
          <div
            @click="selectKey('tek_value24'), (row_click_type = {type: true, value: 'value24'})"
            style="width: 500px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value24"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value24"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Oxirgi 6 oy ichida qabul qilgan muolajalari:</label>
          <div
            @click="selectKey('tek_value25'), (row_click_type = {type: true, value: 'value25'})"
            style="width: 450px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value25"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value25"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Dori darmon va oziq ovqatlarga allergiyasi:</label>
          <div
            @click="selectKey('tek_value26'), (row_click_type = {type: true, value: 'value26'})"
            style="width: 450px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value26"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value26"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Ovqatlanishi:</label>
          <div
            @click="selectKey('tek_value27'), (row_click_type = {type: true, value: 'value27'})"
            style="width: 500px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value27"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value27"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <div class="stat-bemor-text">
        <h3 class="sarlovha-style">Umumiy ahvoli (Status preasets objektivus)</h3>
        <label>Umumiy axvoli</label>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'tekshirish' + modalIdCom"
          @click="getShablonDoctor('tek_value28', { type: true, value: 'value28'})"
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (status = 'tek_value28'),
              (row_click_type = { type: true, value: 'value28' })
          "
          v-b-modal="'modal-new-shab-creat-tekshirish' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          max-rows="10"
          style="width: 100%;"
          v-model="selectShablonJson.value28"
          class="input-stile-textarea"
          @input="textChange"
        >
        </textarea>
        <label>Tana harorati</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 80px;"
          v-model="selectShablonJson.value29"
        />
        <label>Bo'yi(cm)</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 80px;"
          v-model="selectShablonJson.value30"
        />
        <label>Vazni(kg)</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 80px;"
          v-model="selectShablonJson.value31"
        />
        <label>Tana vazni indexsi (kg/cm^2)</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 80px;"
          v-model="selectShablonJson.value32"
        />
        <div class="display-flex">
          <label>Hushi</label>
          <div
            @click="selectKey('tek_value33'), (row_click_type = {type: true, value: 'value33'})"
            style="width: 700px"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value33"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value33"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Teri va qornidagi shilliq qavatlarning holati</label>
          <input 
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value34', 'tek_value34')"
            @input="textChange($event)"
            style="width: 600px;"
            v-model="selectShablonJson.value34"
          >
        </div>

        <div class="display-flex">
          <label>Ko'z olmasining oq qismi</label>
          <div
            @click="selectKey('tek_value35'), (row_click_type = {type: true, value: 'value35'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value35"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value35"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Qalqonsimon bez holati</label>
          <div
            @click="selectKey('tek_value36'), (row_click_type = {type: true, value: 'value36'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value36"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value36"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Suyak-mushak tizimi:</label>
          <div
            @click="selectKey('tek_value37'), (row_click_type = {type: true, value: 'value37'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value37"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value37"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Periferik limfa tugunlari holati:</label>
          <div
            @click="selectKey('tek_value38'), (row_click_type = {type: true, value: 'value38'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value38"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value38"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <h3 class="sarlovha-style">Nafas olish tizimi</h3>
        <label>Nafas olish</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 150px;"
          v-model="selectShablonJson.value39"
        />
        <label>NOS</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 150px;"
          v-model="selectShablonJson.value40"
        />
        <label>minutiga</label>
        <div class="display-flex">
          <label>Ko'krak qafasining tuzilishi</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value41', 'tek_value41')"
            @input="textChange($event)"
            style="width: 450px;"
            v-model="selectShablonJson.value41"
          />
        </div>
        <div class="display-flex">
          <label>Pal'patsiyada</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value42', 'tek_value42')"
            @input="textChange($event)"
            style="width: 500px;"
            v-model="selectShablonJson.value42"
          />
        </div>
        <label>Perkutor</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 100px;"
          v-model="selectShablonJson.value43"
        />
        <label>Pastki chegarasi D</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 100px;"
          v-model="selectShablonJson.value44"
        />
        <label>k/o</label>
        <input
          class="input-stile" 
          type="text"
          @input="textChange($event)"
          style="width: 100px;"
          v-model="selectShablonJson.value45"
        />
        <label>k/o</label>
        <div class="display-flex">
          <label>Auskultatsiyada</label>
          <div
            @click="selectKey('tek_value46'), (row_click_type = {type: true, value: 'value46'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value46"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value46"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Uzatiladi</label>
          <div
            @click="selectKey('tek_value47'), (row_click_type = {type: true, value: 'value47'})"
            style="width: 550px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value47"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value47"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Xirillashlar</label>
          <div
            @click="selectKey('tek_value48'), (row_click_type = {type: true, value: 'value48'})"
            style="width: 550px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value48"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value48"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Krepitatsiya</label>
          <div
            @click="selectKey('tek_value49'), (row_click_type = {type: true, value: 'value49'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value49"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value49"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>

          <label>Plevra ishqalanish shovqin</label>
          <div
            @click="selectKey('tek_value50'), (row_click_type = {type: true, value: 'value50'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value50"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value50"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <h3 class="sarlovha-style">Yurak qon tomir tizimi</h3>
        <div class="sarlovha">Ko'krak qafasidagi o'zgarishlar:</div>
        <div class="display-flex">
          <label>1. Ko'krak qafasidagi og'riq, og'riq yoki noxushlik sezasizmi?</label>
          <div
            @click="selectKey('tek_value51'), (row_click_type = {type: true, value: 'value51'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value51"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value51"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>2. Bu og'riq tez yoki tepalikka qarab yurganda paydo boladimi?</label>
          <div
            @click="selectKey('tek_value51'), (row_click_type = {type: true, value: 'value52'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value52"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value52"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <label>3. Agarda og'riq yurib ketayotganingizda paydo bo'sa nima qilasiz?</label>
        <div
          @click="selectKey('tek_value53'), (row_click_type = {type: true, value: 'value53'})"
          style="width: 650px; margin-top: 5px;"
        >
          <v-select
            style="width: 100%;"
            :options="itemShablon"
            ref="doriselect"
            label="name"
            v-model="selectShablonJson.value53"
            @search="ValueSel"
            @input="textChange"
            :reduce="options => options.name"
            @keydown.native="setStatus($event)"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button
                v-if="!selectShablonJson.value53"
                class="btn-select"
                v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
              >
                ...
              </button>
            </template>
            <template
              v-slot:no-options="{
                search,
                searching
              }"
            >
              <template v-if="searching">
                <em
                  ><b>{{ search }}</b></em
                >{{ "бўйича маьлумот йўқ" }}
                <div class="d-flex-center">
                  <b-button
                    class="insertbtn"
                    variant="success"
                    @click="setStatus(45)"
                    v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                  >
                    <b-icon icon="plus" color="#fff"></b-icon>
                  </b-button>
                </div>
                <b> Insert</b>
              </template>
              <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
            </template>
          </v-select>
        </div>

        <label>4. To'xtasangiz og'riq nima bo'ladi?</label>
        <div
          @click="selectKey('tek_value54'), (row_click_type = {type: true, value: 'value54'})"
          style="width: 650px; margin-top: 5px;"
        >
          <v-select
            style="width: 100%;"
            :options="itemShablon"
            ref="doriselect"
            label="name"
            v-model="selectShablonJson.value54"
            @search="ValueSel"
            @input="textChange"
            :reduce="options => options.name"
            @keydown.native="setStatus($event)"
          >
            <template #search="{ attributes, events }">
              <input class="vs__search" v-bind="attributes" v-on="events" />
              <button
                v-if="!selectShablonJson.value54"
                class="btn-select"
                v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
              >
                ...
              </button>
            </template>
            <template
              v-slot:no-options="{
                search,
                searching
              }"
            >
              <template v-if="searching">
                <em
                  ><b>{{ search }}</b></em
                >{{ "бўйича маьлумот йўқ" }}
                <div class="d-flex-center">
                  <b-button
                    class="insertbtn"
                    variant="success"
                    @click="setStatus(45)"
                    v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                  >
                    <b-icon icon="plus" color="#fff"></b-icon>
                  </b-button>
                </div>
                <b> Insert</b>
              </template>
              <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
            </template>
          </v-select>
        </div>

        <div class="display-flex">
          <label>5. Qanchalik tez vaqtda?</label>
          <div
            @click="selectKey('tek_value55'), (row_click_type = {type: true, value: 'value55'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value55"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value55"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <div class="sarlovha">Yurak o'ynog'i:</div>
          <div
            @click="selectKey('tek_value56'), (row_click_type = {type: true, value: 'value56'})"
            style="width: 150px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value56"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value56"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Paydo bolish sharoiti</label>
          <div
            @click="selectKey('tek_value57'), (row_click_type = {type: true, value: 'value57'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value57"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value57"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>To'xtash sharoiti</label>
          <div
            @click="selectKey('tek_value58'), (row_click_type = {type: true, value: 'value58'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value58"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value58"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <div class="sarlovha">Xansirash:</div>
          <div
            @click="selectKey('tek_value56'), (row_click_type = {type: true, value: 'value59'})"
            style="width: 150px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value59"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value59"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Paydo bolish sharoiti</label>
          <div
            @click="selectKey('tek_value60'), (row_click_type = {type: true, value: 'value60'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value60"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value60"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>To'xtash sharoiti</label>
          <div
            @click="selectKey('tek_value61'), (row_click_type = {type: true, value: 'value61'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value61"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value61"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Qancha vaqtdan beri bor</label>
          <div
            @click="selectKey('tek_value62'), (row_click_type = {type: true, value: 'value62'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value62"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value62"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        
        <div class="display-flex">
          <div class="sarlovha">Oyoq og'rig'i:</div>
          <div
            @click="selectKey('tek_value56'), (row_click_type = {type: true, value: 'value63'})"
            style="width: 150px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value63"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value63"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Boldirda og'riq paydo bo'lishi</label>
          <div
            @click="selectKey('tek_value64'), (row_click_type = {type: true, value: 'value64'})"
            style="width: 450px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value64"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value64"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Agar yurganda bo'lsa qancha vaqt davom etadi</label>
          <div
            @click="selectKey('tek_value65'), (row_click_type = {type: true, value: 'value65'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value65"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value65"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Qanday holatda o'tadi</label>
          <div
            @click="selectKey('tek_value66'), (row_click_type = {type: true, value: 'value66'})"
            style="width: 500px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value66"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value66"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: space-between;">
      <div class="stat-bemor-text">
        <div class="display-flex">
          <div class="sarlovha">Shish</div>
          <div
            @click="selectKey('tek_value56'), (row_click_type = {type: true, value: 'value67'})"
            style="width: 150px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value67"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value67"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Joylari</label>
          <div
            @click="selectKey('tek_value68'), (row_click_type = {type: true, value: 'value68'})"
            style="width: 450px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value68"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value68"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Qancha vaqtlradan beri bor</label>
          <div
            @click="selectKey('tek_value69'), (row_click_type = {type: true, value: 'value69'})"
            style="width: 400px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value69"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value69"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>Qaysi vaqtda paydo bo'ladi</label>
          <div
            @click="selectKey('tek_value70'), (row_click_type = {type: true, value: 'value70'})"
            style="width: 400px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value70"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value70"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Nima yordam beradi</label>
          <div
            @click="selectKey('tek_value71'), (row_click_type = {type: true, value: 'value71'})"
            style="width: 400px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value71"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value71"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <div class="sarlovha">Vazin o'zgarishi</div>
          <div
            @click="selectKey('tek_value72'), (row_click_type = {type: true, value: 'value72'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value72"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value72"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div>
          <label>Qancha miqdorda</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 100px;"
            v-model="selectShablonJson.value73"
          />
          <label>kg, qancha vaqtda</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 100px;"
            v-model="selectShablonJson.value74"
          />
        </div>

        <div>
          <label>Arterial qon bosimi (mm. cim. ust):</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 400px;"
            v-model="selectShablonJson.value75"
          />
        </div>

        <div>
          <label>Ritmi:</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value76', 'tek_value76')"
            @input="textChange($event)"
            style="width: 600px;"
            v-model="selectShablonJson.value76"
          />
        </div>
        <div>
          <label>Puls kattaligi (to'liqligi va tarangligi):</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value77', 'tek_value77')"
            @input="textChange($event)"
            style="width: 500px;"
            v-model="selectShablonJson.value77"
          />
        </div>
        <div>
          <label>Fo'rmasi:</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value78', 'tek_value78')"
            @input="textChange($event)"
            style="width: 600px;"
            v-model="selectShablonJson.value78"
          />
        </div>

        <div>
          <label>Yurak bukri:</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value79', 'tek_value79')"
            @input="textChange($event)"
            style="width: 600px;"
            v-model="selectShablonJson.value79"
          />
        </div>

        <label>2. Tomirlarining pulsatsiyasi:</label>
        <div>
          <label>bo'yin Ch</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value80"
          />
          <label>O'</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value81"
          />
          <label>, qo'l Ch</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value82"
          />
          <label>O'</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value83"
          />
          <label>, oyoq Ch</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value84"
          />
          <label>O'</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange($event)"
            style="width: 70px;"
            v-model="selectShablonJson.value85"
          />
        </div>
        <label>Venalarning varikoz kengayishi tanada va qo'l-oyoqlarda:</label>
        <input
          class="input-stile" 
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value86', 'tek_value86')"
          @input="textChange($event)"
          style="width: 600px;"
          v-model="selectShablonJson.value86"
        />
        <h3 class="sarlovha-style left">Palpalatsiya</h3>
        <div>
          <label>1. Yurak cho'qqisining turtkisi</label>
          <input
            class="input-stile" 
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value87', 'tek_value87')"
            @input="textChange($event)"
            style="width: 450px;"
            v-model="selectShablonJson.value87"
          />
        </div>

        <div class="display-flex">
          <label>2. "Mushuk hirrillashi" (3-5 qovurg'a oralig'i chapda)</label>
          <div
            @click="selectKey('tek_value88'), (row_click_type = {type: true, value: 'value88'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value88"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value88"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>3. Tetrosternal pulsatsiya</label>
          <div
            @click="selectKey('tek_value88'), (row_click_type = {type: true, value: 'value89'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value89"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value89"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <div class="display-flex">
          <label>3. Epigastral pulsatsiya</label>
          <div
            @click="selectKey('tek_value88'), (row_click_type = {type: true, value: 'value90'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value90"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value90"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <h3 class="sarlovha-style left">Perkussiya</h3>
        <label>Yurakning nisbiy bug'iqligi</label>
        <div class="display-flex">
          <label>Chegarasi. Chap</label>
          <div
            @click="selectKey('tek_value91'), (row_click_type = {type: true, value: 'value91'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value91"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value91"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>

          <label>O'ng</label>
          <div
            @click="selectKey('tek_value92'), (row_click_type = {type: true, value: 'value92'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value92"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value92"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Yuqori</label>
          <div
            @click="selectKey('tek_value93'), (row_click_type = {type: true, value: 'value93'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value93"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value93"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <div class="stat-bemor-text">
        <h3 class="sarlovha-style left">Auskultatsiya</h3>
        <label>Yurak tonlari:</label>
        <label>I ton</label>
        <input
          class="input-stile" 
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value94', 'tek_value94')"
          @input="textChange($event)"
          style="width: 600px;"
          v-model="selectShablonJson.value94"
        />
        <br>
        <label>II ton</label>
        <input
          class="input-stile" 
          type="text"
          @blur="handleBlur($event)"
          @focus="showDiv($event, 'value95', 'tek_value95')"
          @input="textChange($event)"
          style="width: 600px;"
          v-model="selectShablonJson.value95"
        />
        <h3 class="sarlovha-style left">Yurak shovqinlari</h3>
        <label>Cisotlik:</label>
        <div class="display-flex">
          <label>Yurak cho'qqisida</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value96'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value96"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value96"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <label>aorta</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value97'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value97"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value97"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>o'pka arteriasida</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value98'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value98"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value98"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <label>Diastolik:</label>
        <div class="display-flex">
          <label>Yurak cho'qqisida</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value99'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value99"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value99"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <label>aorta</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value100'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value100"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value100"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>o'pka arteriasida</label>
          <div
            @click="selectKey('tek_value96'), (row_click_type = {type: true, value: 'value101'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value101"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value101"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Yurakdan tashqari:</label>
          <div
            @click="selectKey('tek_value102'), (row_click_type = {type: true, value: 'value102'})"
            style="width: 200px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value102"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value102"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <h3 class="sarlovha-style">Hazm qilish tizimi</h3>
        <div class="display-flex">
          <div style="width: 50%;">
            <div class="display-flex">
              <label>Tili</label>
              <div
                @click="selectKey('tek_value103'), (row_click_type = {type: true, value: 'value103'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value103"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value103"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Qorin terisi</label>
              <div
                @click="selectKey('tek_value104'), (row_click_type = {type: true, value: 'value104'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value104"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value104"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Jigar</label>
              <div
                @click="selectKey('tek_value105'), (row_click_type = {type: true, value: 'value105'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value105"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value105"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
          </div>

          <div style="width: 50%;">
            <div class="display-flex">
              <label>Bodomsimon bez</label>
              <div
                @click="selectKey('tek_value106'), (row_click_type = {type: true, value: 'value106'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value106"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value106"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Qorin</label>
              <div
                @click="selectKey('tek_value107'), (row_click_type = {type: true, value: 'value107'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value107"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value107"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Kurlov bo'yincha o'lchami</label>
              <div
                @click="selectKey('tek_value108'), (row_click_type = {type: true, value: 'value108'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value108"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value108"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </div>
        <div class="display-flex">
          <label>Taloq</label>
          <div
            @click="selectKey('tek_value109'), (row_click_type = {type: true, value: 'value109'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value109"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value109"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
          <label>Astsit</label>
          <div
            @click="selectKey('tek_value110'), (row_click_type = {type: true, value: 'value110'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value110"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value110"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Shetkin simptomi</label>
          <div
            @click="selectKey('tek_value111'), (row_click_type = {type: true, value: 'value111'})"
            style="width: 250px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value111"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value111"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Ich kelishi</label>
          <div
            @click="selectKey('tek_value112'), (row_click_type = {type: true, value: 'value112'})"
            style="width: 600px; margin-top: 5px;"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value112"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  v-if="!selectShablonJson.value112"
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>

        <h3 class="sarlovha-style">Siydik ajralish tizimi</h3>
        <div class="display-flex">
          <div style="width: 50%;">
              <div class="display-flex">
                <label>Dizurik o'zgarish</label>
                <div
                  @click="selectKey('tek_value113'), (row_click_type = {type: true, value: 'value113'})"
                  style="width: 250px; margin-top: 5px;"
                >
                  <v-select
                    style="width: 100%;"
                    :options="itemShablon"
                    ref="doriselect"
                    label="name"
                    v-model="selectShablonJson.value113"
                    @search="ValueSel"
                    @input="textChange"
                    :reduce="options => options.name"
                    @keydown.native="setStatus($event)"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        v-if="!selectShablonJson.value113"
                        class="btn-select"
                        v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                      >
                        ...
                      </button>
                    </template>
                    <template
                      v-slot:no-options="{
                        search,
                        searching
                      }"
                    >
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >{{ "бўйича маьлумот йўқ" }}
                        <div class="d-flex-center">
                          <b-button
                            class="insertbtn"
                            variant="success"
                            @click="setStatus(45)"
                            v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                          >
                            <b-icon icon="plus" color="#fff"></b-icon>
                          </b-button>
                        </div>
                        <b> Insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="display-flex">
                <label>Sutkalik diures</label>
                <div
                  @click="selectKey('tek_value114'), (row_click_type = {type: true, value: 'value114'})"
                  style="width: 250px; margin-top: 5px;"
                >
                  <v-select
                    style="width: 100%;"
                    :options="itemShablon"
                    ref="doriselect"
                    label="name"
                    v-model="selectShablonJson.value114"
                    @search="ValueSel"
                    @input="textChange"
                    :reduce="options => options.name"
                    @keydown.native="setStatus($event)"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        v-if="!selectShablonJson.value114"
                        class="btn-select"
                        v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                      >
                        ...
                      </button>
                    </template>
                    <template
                      v-slot:no-options="{
                        search,
                        searching
                      }"
                    >
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >{{ "бўйича маьлумот йўқ" }}
                        <div class="d-flex-center">
                          <b-button
                            class="insertbtn"
                            variant="success"
                            @click="setStatus(45)"
                            v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                          >
                            <b-icon icon="plus" color="#fff"></b-icon>
                          </b-button>
                        </div>
                        <b> Insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="display-flex">
                <label>Siydik ajratish</label>
                <div
                  @click="selectKey('tek_value115'), (row_click_type = {type: true, value: 'value115'})"
                  style="width: 250px; margin-top: 5px;"
                >
                  <v-select
                    style="width: 100%;"
                    :options="itemShablon"
                    ref="doriselect"
                    label="name"
                    v-model="selectShablonJson.value115"
                    @search="ValueSel"
                    @input="textChange"
                    :reduce="options => options.name"
                    @keydown.native="setStatus($event)"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        v-if="!selectShablonJson.value115"
                        class="btn-select"
                        v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                      >
                        ...
                      </button>
                    </template>
                    <template
                      v-slot:no-options="{
                        search,
                        searching
                      }"
                    >
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >{{ "бўйича маьлумот йўқ" }}
                        <div class="d-flex-center">
                          <b-button
                            class="insertbtn"
                            variant="success"
                            @click="setStatus(45)"
                            v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                          >
                            <b-icon icon="plus" color="#fff"></b-icon>
                          </b-button>
                        </div>
                        <b> Insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
          </div>
  
          <div style="width: 50%;">
            <div class="display-flex">
              <label>Siydik rangi</label>
              <div
                @click="selectKey('tek_value116'), (row_click_type = {type: true, value: 'value116'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value116"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value116"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Turtki belgisi</label>
              <div
                @click="selectKey('tek_value117'), (row_click_type = {type: true, value: 'value117'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value117"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value117"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
            <div class="display-flex">
              <label>Tiniqligi</label>
              <div
                @click="selectKey('tek_value118'), (row_click_type = {type: true, value: 'value118'})"
                style="width: 250px; margin-top: 5px;"
              >
                <v-select
                  style="width: 100%;"
                  :options="itemShablon"
                  ref="doriselect"
                  label="name"
                  v-model="selectShablonJson.value118"
                  @search="ValueSel"
                  @input="textChange"
                  :reduce="options => options.name"
                  @keydown.native="setStatus($event)"
                >
                  <template #search="{ attributes, events }">
                    <input class="vs__search" v-bind="attributes" v-on="events" />
                    <button
                      v-if="!selectShablonJson.value118"
                      class="btn-select"
                      v-b-modal="'shablon-select' + 'select-doc-text' + modalIdCom"
                    >
                      ...
                    </button>
                  </template>
                  <template
                    v-slot:no-options="{
                      search,
                      searching
                    }"
                  >
                    <template v-if="searching">
                      <em
                        ><b>{{ search }}</b></em
                      >{{ "бўйича маьлумот йўқ" }}
                      <div class="d-flex-center">
                        <b-button
                          class="insertbtn"
                          variant="success"
                          @click="setStatus(45)"
                          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                        >
                          <b-icon icon="plus" color="#fff"></b-icon>
                        </b-button>
                      </div>
                      <b> Insert</b>
                    </template>
                    <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                  </template>
                </v-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :id="'shablon-select' + 'select-doc-text' + modalIdCom"
      size="xl"
      hide-footer
    >
      <div style="display: flex; justify-content: space-between;">
        <button
          class="navbarBtnTashxis mb-2"
          v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
          @click="plusClick"
        >
          <b-icon icon="plus-lg"></b-icon>
        </button>

        <b-form-group
          label-for="filterTekshiruvlar-input"
          label-cols-sm="1"
          label-align-sm="right"
          label-size="sm"
          class="mb-2 col-8"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterTekshiruvlar-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Қидирув')"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                variant="danger"
                @click="filter = ''"
              >
                {{ $t("Тозалаш") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <b-table
          id="bemor-table"
          ref="refTable"
          hover
          sort-icon-left
          striped
          primary-key="id"
          :items="itemShablon"
          :fields="fields"
          :filter="filter"
          :current-page="currentPage"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @row-clicked="RowClickedShab($event, null, true)"
          stacked="md"
          show-empty
          small
          @filtered="onFiltered"
        >
          <template #cell(№)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(actions)="row">
            <b-row class="ml-1">
              <section
                style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
              >
                <div style="display: flex;">
                  <b-button
                    v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
                    variant="outline-primary"
                    @click="userLink(row.item)"
                    class="pencil"
                  >
                    <b-icon
                      style="width: 15px;"
                      variant="outline-primary"
                      icon="pencil-fill"
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>
                  <div>
                    <b-button
                      class="trash ml-2"
                      style=""
                      variant="outline-danger"
                      @click="trash(row.item.id)"
                    >
                      <b-icon
                        style="width: 15px;"
                        icon="trash-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </b-button>
                  </div>
                </div>
              </section>
            </b-row>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      :id="'modal-shab-select-create-doc-text' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      size="lg"
      hide-footer
    >
      <div>
        <b-input
          type="text"
          style="border: 1px solid #ccc; border-radius: 5px;"
          v-model="datas.name"
        >
        </b-input>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="Close()"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="Shablon()"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      :style="{
        top: divPosition.top + 'px',
        left: divPosition.left + 'px',
        width: divPosition.width + 'px',
        display: show ? 'block' : 'none'
      }"
      class="dynamic-div-tek"
    >
      <div
        v-for="item in itemShablon"
        class="drop-down"
        @click="selectItemValue(item.name)"
      >
        {{ item.name }}
        <div class="display-flex">
          <b-button
            v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
            variant="outline-primary"
            style="width: 30px; height: 30px"
            @click="userLink(row.item)"
            class="pencil"
          >
            <b-icon
              style="width: 10px;"
              variant="outline-primary"
              icon="pencil-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
          <b-button
            class="trash ml-2"
            style="width: 30px; height: 30px"
            variant="outline-danger"
            @click="trash(item.id)"
          >
            <b-icon
              style="width: 10px;"
              icon="trash-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
        </div>
      </div>
      <b-button
        class="insertbtn"
        style="align-items: center; text-align: center;"
        variant="success"
        @click="setStatus(45)"
        v-b-modal="'modal-shab-select-create-doc-text' + modalIdCom"
      >
        <b-icon icon="plus" color="#fff"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import Shablon from '../Shifokor/Shablon.vue';
export default {
  props: ["statsionar_text", "modalIdCom"],
  components: {
    Shablon
  },
  data() {
    return {
      options: [],
      show: false,
      row_click_type: {
          type: false,
          value: ""
        },
      name: '',
      itemsShablon: [],
      datas: {
        id: 0,
        name: "",
        status: ""
      },
      status: "",
      divPosition: {
        top: 0,
        left: 0,
        with: 0
      },
      key: "",
      selectShablonJson: {},
      itemShablon: [],
      status: "",
      ValueSelect: "",
      fields: [
        "№",
        { key: "name", label: "Номи", sortable: true },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  created() {
    if (this.statsionar_text == "" || !this.statsionar_text) {
      this.selectShablonJson = {
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        value9: null,
        value10: null,
        value11: null,
        value12: null,
        value13: null,
        value14: null,
        value15: null,
        value16: null,
        value17: null,
        value18: null,
        value19: null,
        value20: null,
        value21: null,
        value22: null,
        value23: null,
        value24: null,
        value25: null,
        value26: null,
        value27: null,
        value28: null,
        value29: null,
        value30: null,
        value31: null,
        value32: null,
        value33: null,
        value34: null,
        value35: null,
        value36: null,
        value37: null,
        value38: null,
        value39: null,
        value40: null,
        value41: null,
        value42: null,
        value43: null,
        value44: null,
        value45: null,
        value46: null,
        value47: null,
        value48: null,
        value49: null,
        value50: null,
        value51: null,
        value52: null,
        value53: null,
        value54: null,
        value55: null,
        value56: null,
        value57: null,
        value58: null,
        value59: null,
        value60: null,
        value61: null,
        value62: null,
        value63: null,
        value64: null,
        value65: null,
        value66: null,
        value67: null,
        value68: null,
        value69: null,
        value70: null,
        value71: null,
        value72: null,
        value73: null,
        value74: null,
        value75: null,
        value76: null,
        value77: null,
        value78: null,
        value79: null,
        value80: null,
        value81: null,
        value82: null,
        value83: null,
        value84: null,
        value85: null,
        value86: null,
        value87: null,
        value88: null,
        value89: null,
        value90: null,
        value91: null,
        value92: null,
        value93: null,
        value94: null,
        value95: null,
        value96: null,
        value97: null,
        value98: null,
        value99: null,
        value100: null,
        value101: null,
        value102: null,
        value103: null,
        value104: null,
        value105: null,
        value106: null,
        value107: null,
        value108: null,
        value109: null,
        value110: null,
        value111: null,
        value112: null,
        value113: null,
        value114: null,
        value115: null,
        value116: null,
        value117: null,
        value118: null,
        value119: null,
        value120: null,
      };
    } else {
      this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
    }
  },
  watch: {
    statsionar_text(newVal, old){
      this.selectShablonJson = JSON.parse(newVal.toString())
    }
  },
  methods: {
    allPechat(){
      let t = {};
      t = {
        value: this.statsionar_text
      };
      localStorage.setItem("StatDoctor", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-stat-doctor"
      });
      window.open(rout.href, "_blank");
    },
    ShifokorShablonClose(){
      this.name = ''
      this.$bvModal.hide(`${'modal-new-shab-creat-tekshirish' + this.modalIdCom}`);
    },
    selectItemValue(value) {
      if (this.selectShablonJson[`${this.row_click_type.value}`] == null) {
        this.selectShablonJson[`${this.row_click_type.value}`] = value;
      } else {
        this.selectShablonJson[`${this.row_click_type.value}`] += ` ${value}`;
      }
      setTimeout(() => {
        this.show = false;
      }, 500);
      this.textChange();
    },
    showDiv(event, key, status) {
      this.row_click_type.value = key;
      this.status = status;
      this.getShablon(status);
      const input = event.target;
      const rect = input.getBoundingClientRect();
      this.divPosition.top = rect.top + window.pageYOffset + rect.height - 365;
      this.divPosition.left = rect.left + window.pageXOffset - 20;
      this.divPosition.width = rect.width;
      setTimeout(() => {
        this.handleBlur("", true);
      }, 200);
    },
    handleBlur(event, type) {
      if (!type) {
        setTimeout(() => {
          this.show = false;
        }, 100);
      } else {
        this.show = true;
      }
    },
    RowClickedShab($events, ind, type) {
      if (this.row_click_type.type) { 
        this.selectShablonJson[`${this.row_click_type.value}`] = type ? $events.name : $events.text;
      } else {
        let text = JSON.parse($events.text.toString());
        this.selectShablonJson = text;
      }
      this.textChange()
      this.$bvModal.hide(`${"modal-shablon" + "tekshirish" + this.modalIdCom}`);
      this.$bvModal.hide('shablon-select' + 'select-doc-text' + this.modalIdCom)
    },
    getShablonDoctor(key, type) {
      let self = this;
      self.status = key;
      self.row_click_type = type;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: 1,
          doc_type: key
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    ShifokorShablon(){
      let self = this
      let text = "";
      if (self.row_click_type.type) {
        text = self.selectShablonJson[self.row_click_type.value];
      } else {
        text = JSON.stringify(self.selectShablonJson).toString();
      }
      axios({
          method: "post",
          url: "/shablon_doctor/create",
          data: {
            name: self.name,
            text: text,
            doctor_id: 1,
            doc_type: self.status ? self.status : "tekshirish"
          }
        }).then(res => {
          if (res) {
            self.name = ''
            self.$bvModal.hide(`${'modal-new-shab-creat-tekshirish' + self.modalIdCom}`);
          }
        });
    },
    textChange() {
      this.$emit(
        "statsionar_text_change",
        JSON.stringify(this.selectShablonJson).toString(), 'tekshirish'
      );
    },
    plusClick() {
      this.datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    setStatus($events) {
      if ($events.keyCode == 45 || $events == 45) {
        this.datas = {
          name: this.ValueSelect,
          status: this.status
        };
        this.$bvModal.show("modal-shab-select-create-doc-text" + this.modalIdCom);
      }
    },
    selectKey(key) {
      this.status = key;
      this.getShablon(key);
    },
    getShablon(status) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_select/shablonOne",
        data: { status: status }
      }).then(res => {
        if (res) {
          self.itemShablon = res.data.data;
        }
      });
    },
    userLink(item) {
      this.datas = item;
      this.$bvModal.show("modal-shab-select-create-doc-text" + this.modalIdCom);
    },
    trash(id) {
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_select/delete/" + id
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          // self.$bvModal.hide('modal-shab-select-create-doc-text' + self.index + self.modalIdCom);
        }
      });
    },
    ValueSelChange() {
      let value = JSON.stringify(this.statsionar_text);
      // console.log(this.statsionar_text, value);
      this.$emit("selectSablon", value, this.index);
      // this.shablonData = JSON.stringify(this.statsionar_text)
    },
    ValueSel(e) {
      this.ValueSelect = e;
    },
    Shablon() {
      let self = this;
      let method = "";
      let url = "";
      if (this.datas.id) {
        method = "patch";
        url = "/shablon_select/update/" + self.datas.id;
      } else {
        self.datas.status = self.status;
        method = "post";
        url = "/shablon_select/create";
      }
      axios({
        method: method,
        url: url,
        data: self.datas
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          self.$bvModal.hide("modal-shab-select-create-doc-text" + self.modalIdCom);
          self.datas = {
            id: 0,
            name: "",
            status: ""
          };
        }
      });
    },
    Close() {
      datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
.dynamic-div-tek {
  min-width: 150px;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 5;
  cursor: pointer;
  display: none;
  .drop-down {
    cursor: pointer;
    align-items: center;
    height: 35px;
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    font-size: 13pt;
  }
}
.drop-down:hover {
  background: rgb(46, 165, 255);
  color: #fff;
}
.vueTextEditor .ql-editor{
  p{
    font-size: 13pt;
    font-weight: 500;
  }
}
.izoh-style{
  font-size: 9pt;
  margin-top: -3px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
}
.sarlovha{
  font-family: 'Times New Roman';
  font-size: 14pt;
  font-weight: 600;
  font-style: oblique;
}
.sarlovha-style{
  margin-top: 10px;
  text-align: center;
  font-family: 'Times New Roman';
}
.left{
  text-align: left;
}
.stat-bemor-text {
  margin-bottom: 10px;
  width: 49.5%;
  padding: 10px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  label {
    font-family: 'Times New Roman', Times, serif;
    margin-top: 5px;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
  }
}
.input-stile {
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: 'Times New Roman', Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.input-stile-textarea{
  margin-top: 5px;
  font-family: 'Times New Roman', Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.display-flex {
  display: flex;
}
.btn-select {
  background-color: #fff0;
  // border: none;
  // border: 1px  solid #000;
  // border-radius: 50%;
  font-size: 14pt;
  font-weight: 700;
  height: 27px;
  width: 27px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: calc(50% - 13px);
  right: 0px;
  color: #6c6868;
  /* left: -50px; */
}
</style>
